module.exports = __webpack_public_path__ + "img/shield_unselected.985e78b3.png";